import {
    DEVICES_BULK_PAIRING_OPEN_MODAL,
    DEVICES_BULK_PAIRING_CLOSE_MODAL,
    DEVICES_BULK_PAIRING_REQUEST,
    DEVICES_BULK_PAIRING_RESULT,
    DEVICES_BULK_PAIRING_SEARCH_DEVICES_REQUEST,
    DEVICES_BULK_PAIRING_SEARCH_DEVICES_RESULT,
    DEVICES_BULK_PAIRING_SEARCH_ID_REQUEST,
    DEVICES_BULK_PAIRING_SEARCH_ID_RESULT,
} from 'Redux/actionTypes';
export const bulkPairingOpenModal = () => ({
    type: DEVICES_BULK_PAIRING_OPEN_MODAL,
});

export const bulkPairingCloseModal = () => ({
    type: DEVICES_BULK_PAIRING_CLOSE_MODAL
});

export const bulkPairingRequest = (data) => ({
    type: DEVICES_BULK_PAIRING_REQUEST,
    payload: data
});

export const bulkPairingResult = (result) => ({
    type: DEVICES_BULK_PAIRING_RESULT,
    payload: result
});

export const bulkPairingSearchDevicesRequest = (data) => ({
    type: DEVICES_BULK_PAIRING_SEARCH_DEVICES_REQUEST,
    payload: data
});

export const bulkPairingSearchDevicesResult = (result) => ({
    type: DEVICES_BULK_PAIRING_SEARCH_DEVICES_RESULT,
    payload: result
});

export const bulkPairingSearchIdRequest = (devices, type) => ({
    type: DEVICES_BULK_PAIRING_SEARCH_ID_REQUEST,
    payload: { devices, type }
});

export const bulkPairingSearchIdResult = (result, type) => ({
    type: DEVICES_BULK_PAIRING_SEARCH_ID_RESULT,
    payload: { result, type }
});